



























import { mapGetters, mapActions } from 'vuex'
import { applyCustomErrorConfig } from '@/custom-errors'
import parseErrorMessage from '@/parse-error-message'
import PageContent from '@/components/PageContent.vue'
import Card from '@/components/Card.vue'
import ContactCard from '@/components/ContactCard.vue'
import RegistrationForm from './RegistrationForm.vue'
import ProcessSteps from './ProcessSteps.vue'

export default {
  components: {
    PageContent,
    Card,
    ContactCard,
    RegistrationForm,
    ProcessSteps
  },
  data() {
    return {
      sennderContact: {
        firstName: 'Aleksandra',
        lastName: 'Lyson',
        jobTitle: 'Partner Manager',
        email: 'aleksandra.lyson@sennder.com',
        phone: '+49 (0) 30 3080 9381'
      },
      loading: true,
      refFormId: 0
    }
  },
  computed: {
    ...mapGetters(['truckTypes', 'companyDetails', 'transportIsSending']),
    vehicleTypesArray() {
      return Object.keys(this.truckTypes).map(key => ({
        id: key,
        label: this.truckTypes[key]
      }))
    }
  },
  async created() {
    await this.loadCompanyDetails()
    this.loading = false
  },
  methods: {
    ...mapActions(['loadCompanyDetails', 'submitTransportRegistration']),
    async registerTransport(newTransport) {
      try {
        await this.submitTransportRegistration(newTransport)
        this.alertModal.showSuccessMessage(
          this.$t(
            'myTransports.transportDetails.onSubmittingTransportInfo.sweetAlert.successTitle'
          ),
          this.$t(
            'myTransports.transportDetails.onSubmittingTransportInfo.sweetAlert.successMsg'
          )
        )
        this.resetForm()
      } catch (err) {
        this.alertModal.showErrorMessage(
          this.$t(
            'myTransports.transportDetails.onSubmittingTransportInfo.sweetAlert.errorMsg'
          ),
          parseErrorMessage(err.message),
          applyCustomErrorConfig
        )
      }
    },
    resetForm() {
      /* We need to force the form to rerender after succesful submit
       cause if we just reset its state it will display input validation errors. 
       See more here: 
       https://github.com/sennder/plankton/blob/master/src/mixins/field-validator-mixin.js */
      this.refFormId += 1
    }
  }
}
